import { IColumns } from '../../../../../components/Dashboard/Table/TableTypes'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'staking/history',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'type',
      label: 'ACTION',
      // eslint-disable-next-line
      format: (value: string) => {
        return value.replace('_', ' ').replace(/\b[a-z]/g, (match: string) => match.toUpperCase())
      },
    },
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'timestamp',
      label: 'TIME STAMP',
      // eslint-disable-next-line
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      },
    },
    {
      id: 'id',
      label: 'ORDER ID',
    },
  ],
}
